export default __webpack_public_path__ + "static/media/push-icon.0d2f681b.svg";